/**
 * Shared label + Spark icon slug for the "add data" menu entries, so the
 * wizard "Need a Dataset?" dropdown and the Data Overview / task-page
 * AddDataButton menu stay consistent (Figma 3081-5906).
 */
export const ADD_DATA_MENU_ITEMS = Object.freeze({
    upload: Object.freeze({ label: 'Upload Data', iconSlug: 'upload' }),
    library: Object.freeze({ label: 'Choose from your uploads', iconSlug: 'library' }),
    huggingface: Object.freeze({ label: 'Use Hugging Face', iconSlug: 'huggingface' }),
    generateAi: Object.freeze({ label: 'Generate data with AI', iconSlug: 'sparkles-2' }),
    retrievalAgent: Object.freeze({ label: 'Retrieval Agent', iconSlug: 'agent' }),
});

export const RETRIEVAL_AGENT_MENU_INFO =
    'Find and retrieve public datasets from Hugging Face and Kaggle.';

/**
 * Ordered add-data actions. Upload is first when included (Data Overview "+");
 * Need a Dataset omits it. Remaining entries share this order on both menus.
 */
export function buildAddDataMenuItems({
    includeUpload = false,
    includeLibrary = false,
    includeHuggingFace = false,
    includeGenerateAi = false,
    includeRetrievalAgent = false,
    onUpload,
    onLibrary,
    onHuggingFace,
    onGenerateAi,
    onRetrievalAgent,
} = {}) {
    const items = [];
    const push = (def, onClick, extra) => {
        if (!onClick) return;
        items.push({ ...def, onClick, ...extra });
    };
    if (includeUpload) push(ADD_DATA_MENU_ITEMS.upload, onUpload);
    if (includeLibrary) push(ADD_DATA_MENU_ITEMS.library, onLibrary);
    if (includeHuggingFace) push(ADD_DATA_MENU_ITEMS.huggingface, onHuggingFace);
    if (includeGenerateAi) push(ADD_DATA_MENU_ITEMS.generateAi, onGenerateAi);
    if (includeRetrievalAgent) {
        push(ADD_DATA_MENU_ITEMS.retrievalAgent, onRetrievalAgent, {
            showInfoIcon: true,
            infoText: RETRIEVAL_AGENT_MENU_INFO,
        });
    }
    return items;
}

/** Map builder rows onto Spark `PopoverMenu` item props. */
export function toPopoverMenuItems(items, { onClose } = {}) {
    return (items || []).map((item) => ({
        label: item.label,
        showPrefixIcon: true,
        prefixIconSlug: item.iconSlug,
        showInfoIcon: Boolean(item.showInfoIcon),
        infoText: item.infoText,
        disableWhenReadOnly: true,
        onClick: () => {
            onClose?.();
            item.onClick?.();
        },
    }));
}
